import {ObjectIdSchema} from '../../zod';
import {ApiDefinition} from '../definitions';
import {z} from 'zod';

export const GetScoringInfo = {
  path: 'scoredAccounts/scoringInfo',
  method: 'get',
  options: {access: 'all'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.object({
    isRescoring: z.boolean(),
    latestRefreshTimestamp: z.date().optional(),
    latestScoringRunId: ObjectIdSchema.optional(),
  }),
} satisfies ApiDefinition;
